import AntdTable from 'components/AntdTable';
import { useMemo } from 'react';
import { TooltipHide } from 'page/Application/ManageCompanyList/CompanyList/styled';
import { Tooltip } from 'antd';

const TableData = ({
  isLoading,
  dataSource,
  emptyText,
  onChange,
  AccessTableType = 'ACCESS_BY_PAGE',
}) => {
  const regexNumber = /\B(?=(\d{3})+(?!\d))/g;
  const AccessPage = {
    title1: 'ランキング',
    key1: 'rank',
    title2: 'ページタイトル',
    key2: 'pageTitle',
    title3: '訪問数',
    key3: 'count',
    title4: 'プロダクト',
    key4: 'productName',
  };
  const AccessPartner = {
    title1: 'ランキング',
    key1: 'rank',
    title2: '会社名',
    key2: 'partnerName',
    title3: '訪問数',
    key3: 'count',
  };
  const AccessAccount = {
    title1: 'ランキング',
    key1: 'rank',
    title2: 'アカウント',
    key2: 'email',
    title3: '訪問数',
    key3: 'count',
  };
  const AccessDate = useMemo(() => {
    return {
      ACCESS_BY_PAGE: AccessPage,
      ACCESS_BY_PARTNER: AccessPartner,
      ACCESS_BY_ACCOUNT: AccessAccount,
    };
  }, []);

  const columns = useMemo(() => {
    return [
      {
        key: AccessDate[AccessTableType]?.key1,
        title: (
          <TooltipHide>
            <Tooltip
              title={AccessDate[AccessTableType]?.title1}
              placement={'topLeft'}
            >
              {AccessDate[AccessTableType]?.title1}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: AccessDate[AccessTableType]?.key1,
        ellipsis: true,
        align: 'left',
        render: (rank) => (
          <TooltipHide>
            <Tooltip title={rank} placement={'topLeft'}>
              {rank}
            </Tooltip>
          </TooltipHide>
        ),
        width: 120,
      },
      {
        key: AccessDate[AccessTableType]?.key2,
        title: (
          <TooltipHide>
            <Tooltip
              title={AccessDate[AccessTableType]?.title2}
              placement={'topLeft'}
            >
              {AccessDate[AccessTableType]?.title2}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: AccessDate[AccessTableType]?.key2,
        align: 'left',
        render: (data) => (
          <TooltipHide>
            <Tooltip title={data} placement={'topLeft'}>
              {data}
            </Tooltip>
          </TooltipHide>
        ),
        ellipsis: true,
      },
      AccessTableType === 'ACCESS_BY_PAGE' && {
        key: AccessDate[AccessTableType]?.key4,
        title: (
          <TooltipHide>
            <Tooltip
              title={AccessDate[AccessTableType]?.title4}
              placement={'topLeft'}
            >
              {AccessDate[AccessTableType]?.title4}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: AccessDate[AccessTableType]?.key4,
        align: 'left',
        render: (data) => (
          <TooltipHide>
            <Tooltip title={data} placement={'topLeft'}>
              {data}
            </Tooltip>
          </TooltipHide>
        ),
        ellipsis: true,
        width: 120,
      },
      {
        key: AccessDate[AccessTableType]?.key3,
        title: (
          <TooltipHide>
            <Tooltip
              title={AccessDate[AccessTableType]?.title3}
              placement={'topLeft'}
            >
              {AccessDate[AccessTableType]?.title3}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: AccessDate[AccessTableType]?.key3,
        align: 'left',
        render: (data) => (
          <TooltipHide>
            <Tooltip
              title={data?.toString()?.replace(regexNumber, ',')}
              placement={'topLeft'}
            >
              {data?.toString()?.replace(regexNumber, ',')}
            </Tooltip>
          </TooltipHide>
        ),
        ellipsis: true,
        width: 90,
      },
    ]?.filter(Boolean);
  }, [AccessDate, AccessTableType]);

  return (
    <>
      <AntdTable
        columns={columns}
        isLoading={isLoading}
        dataSource={dataSource}
        emptyText={emptyText}
        onChange={onChange}
      />
    </>
  );
};

export default TableData;
